<template>
    <div>
        <section class="container-fluid mt-2">
           <!-- <Menu :isInOportunidad="true" :isInContactos="true" :pSitio="NombreSeccion" :pRegresar="false" :pSitioAtras="txtSitio">
            <template slot="BtnInicio">
                <button @click="IrACalendario" type="button" class="btn btn-01">Calendario</button>
				<button @click="IrANuevasOportunidades" type="button" class="btn btn-01">Nuevas Oportunidades</button>
            </template>
            </Menu> -->
            <div class="row">
                <div class="col-md-12 col-lg-12 col-xl-12 mt-2">
                   <Clist :pConfigLoad="ConfigLoad" :isOportunidad="true" :ShowFilas="false" :regresar="false" :pShowBtnAdd="false" @FiltrarC="Lista" :Filtro="Filtro" :Nombre="NameList" :Pag="Pag" :Total="TotalPagina" :isModal="EsModal">
                    <template slot="botonextra">
                		<button @click="IrANuevasOportunidades" type="button" class="btn btn-01 mb-2">Nuevas Oportunidades</button>
            		</template>
					<!-- <template slot="Botonnuevo">
                        <div class="col-md-12 col-lg-6 text-right mt-2">
                            <button type="button" data-toggle="modal" data-target="#ModalForm"  data-backdrop="static" data-keyboard="false" class="btn btn-pink mr-2" @click="Nuevo()">Nueva</button>
                        </div>
                    </template> -->
                    <template slot="Filtros"> 
						<div class="form-group  mr-2">
                		    <v-date-picker
							@input="Lista"
                		    mode='range'
                		    v-model='rangeDate'
                		    :input-props='{
                		    class: "form-control   calendar",
                		    placeholder: "Selecciona un rango de fecha para buscar",
                		    readonly: true
                		    }'/>
                		</div>
                        <label class="mr-2">Estatus</label>
                        <select @change="Lista" v-model="Estado" class="form-control form-control mr-2">
                            <option value="">- Estatus -</option>
                            <option :value="'Activa'">Activa</option>
                            <option :value="'Enviada'">Enviada</option>
                            <option :value="'Ganada'">Ganada</option>
                            <option :value="'Perdida'">Perdida</option>
                            <!-- <option :value="'Inactivo'">Inactivo</option> -->
                        </select>
						<label class="mr-2">Categoría</label>
                        <select @change="Lista" v-model="Categoria" class="form-control form-control mr-2">
                            <option value="">- Categoría -</option>
                            <option :value="'Cliente'">Cliente</option>
                            <option :value="'Prospecto'">Prospecto</option>
                            <option :value="'Suspecto'">Suspecto</option>
                            <option :value="'Inactivo'">Inactivo</option>
                            <!-- <option :value="'Inactivo'">Inactivo</option> -->
                        </select>
						<label v-if="RolUsuario=='Admin' || RolUsuario=='Gerencia' || RolUsuario=='Gerente de ventas'" class="mr-2">Responsable</label>
						<select v-if="RolUsuario=='Admin' || RolUsuario=='Gerencia' || RolUsuario=='Gerente de ventas'" @change="Lista" v-model="Responsable" class="form-control form-control mr-2">
							<option value="">Seleccione una opción</option>
							<option v-for="(item,index) in ListaResponsable" :key="index" :value="item.IdUsuario">{{item.Nombre}}</option>
						</select>
                    </template>
					<template slot="Botonnuevo">
						<div class="col-lg-4 d-flex justify-content-end mt-2 pr-5">
							<span class="ml-3 titulosmonitoreo">Monto Oportunidades Clientes: <span class="titulosmonitoreo text-primary"> ${{ Number(MontoOportunidadesClientes).toLocaleString('es-MX') }}</span> </span>
							<span class="ml-3 titulosmonitoreo">Monto Oportunidades Prospectos: <span class="titulosmonitoreo text-primary"> ${{ Number(MontoOportunidadesProspectos).toLocaleString('es-MX') }}</span> </span>
						</div>
					</template>
                    <template slot="header" v-if="MostrarTodo">
                        <tr>
                            <th>Nombre de Oportunidad</th>
                            <th>Folio</th>
							<th>Categoría</th>
                            <th>Cliente</th>
                            <th>Propiedad</th>
                            <th>Estatus</th>
                            <th v-if="RolUsuario=='Admin'">Responsable</th>
                            <th>Servicio</th>
                            <th>Activa</th>
                            <th>Actualización</th>
                            <th>Acciones</th>
                        </tr>
                    </template>
                    <template slot="header" v-else>
                        <tr>
                            <th>Nombre de Oportunidad</th>
                            <th>Folio</th>
                            <th v-if="RolUsuario=='Admin'">Usuario</th>
                            <th>Servicio</th>
                            <th>Activa</th>
                            <th>Actualización</th>
                            <th>Estatus</th>
                            <th>Acciones</th>
                        </tr>
                    </template>

                    <template slot="body" v-if="MostrarTodo">
                        <tr v-for="(lista,index) in  ListaOportunidades" :key="index" >
                            <td v-b-tooltip.hover.top :title="lista.Nombre">{{$limitCharacters(lista.Nombre,30)}}</td>
                            <td class="tw-2">{{lista.FolioOportunidad}}</td>
							<td>{{lista.Categoria}}</td>
                            <td v-b-tooltip.hover.top :title="lista.NomCliente">{{$limitCharacters(lista.NomCliente,22) }}</td>
                            <td v-b-tooltip.hover.top :title="lista.Sucursal">{{$limitCharacters(lista.Sucursal,22)}}</td>
                            <td>{{lista.Estado}}</td>
                            <td v-if="RolUsuario=='Admin'">{{lista.Vendedor=="" || lista.Vendedor==null ? $limitCharacters(NombreUsuario,26) : $limitCharacters(lista.Vendedor,26)}}</td>
                            <td><i v-show="lista.FechaServicio!==null" class="fa fa-calendar"></i> {{ lista.FechaServicio !==null ? $getCleanDate(lista.FechaServicio,false) : "No Tiene Servicio" }}</td>
                            <td><i class="fa fa-calendar"></i> {{$getCleanDate(lista.FechaReg,false)}}</td>
                            <td><i class="fa fa-calendar"></i> {{$getCleanDate(lista.FechaMod,false)}}</td>
                            <td>
                                <Cbtnaccion  :isModal="EsModal" :Id="lista.IdOportunidad" :IrA="FormName" :pEmitSeccion="EmitSeccion">
                                    <template slot="btnaccion">

                                    </template>
                                </Cbtnaccion>
                            </td>
                        </tr>
                    </template>
                    <template slot="body" v-else>
                        <tr v-for="(lista,index) in  ListaOportunidades" :key="index" >
                            <td>{{$limitCharacters(lista.Nombre,40)}}</td>
                            <td>{{lista.FolioOportunidad}}</td>
                            <td v-if="RolUsuario=='Admin'">{{$limitCharacters(lista.Vendedor,26)}}</td>
                            <td>{{$getCleanDate(lista.FechaReg,false)}}</td>
                            <td>{{lista.Estado}}</td>
                            <td>
                                <Cbtnaccion :isModal="EsModal" :Id="lista.IdOportunidad" :IrA="FormName" :pEmitSeccion="EmitSeccion">
                                    <template slot="btnaccion">

                                    </template>
                                </Cbtnaccion>
                            </td>
                        </tr>
                    </template>
                </Clist>

                <Modal :size="size" :Nombre="NameList" :poBtnSave="oBtnSave"  :pEmitSeccion="EmitSeccion" :NameModal="'oportunidadservicio'">
                    <template slot="Form">
                        <Form :pOrigen="'activa'" @Listar="ListaCliente" :poBtnSave="oBtnSave"></Form>
                    </template>
                </Modal>

                    <Ccliente :Origen="'Oportunidad'" :TipoModal='2'></Ccliente>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import Modal from '@/components/Cmodal.vue';
import Clist from '@/components/Clist.vue';
import Cbtnaccion from '@/components/Cbtnaccion.vue';
import Ccliente from '@/components/Ccliente.vue';
import Form from '../oportunidades/OportunidadesForm.vue';
import Menu from "../oportunidades/indexMenu.vue";

export default {
    name :'list',
    props: ["oclientesorigen","pIdActivaRedireccion","pOrigen","pTitulo"],
    components :{
        Modal,
        Clist,
        Cbtnaccion,
        Form,
        Ccliente,
        Menu,
    },
    data() {
        return {
            NombreSeccion: 'Activas',
            FormName:'TipoUnidadForm',//Por si no es modal y queremos ir a una vista declarada en el router
            EsModal:true,//indica si es modal o no
            size :"modal-xl",
            EmitSeccion:'oportunidadservicio',
            NameList:"Oportunidades Activas",
            urlApi:"crmoportunidad/list",
            RolUsuario:'',
            IdUsuario:'',
            NombreUsuario:'',
            ListaOportunidades:[],
            ListaHeader:[],
            TotalPagina:2,
            Pag:0,
            Estado:"",
			Categoria:"",
			Responsable:"",
			ListaResponsable:[],
			rangeDate:{},
              Filtro:{
                Nombre:'',
                Placeholder:'Nombre/Cliente/Propiedad/Responsable',
                TotalItem:0,
                Pagina:1,
                Entrada: 45
            },
            oBtnSave:{//valores  isModal(true),nombreModal('ModalForm'),tipoModal=1,regresarA(''),disableBtn(false),txtSave('Guardar'),txtCancel('Cerrar');
                isModal:true,
                disableBtn:false,
                toast:0,
                EmitSeccion:'oportunidadservicio',
                nombreModal:'oportunidadservicio',
            },
            oClienteS:{},
            txtSitio:"Calendario",
            MostrarTodo:true,
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
			MontoOportunidadesClientes:0,
			MontoOportunidadesProspectos:0,
        }
    },
    methods: {
        Nuevo()
        {
            if (this.oBtnSave.isModal==true)
            {
                this.bus.$emit('NewModal_'+this.EmitSeccion,true);
            }
            else{
                this.bus.$emit('NewModal_'+this.EmitSeccion);
            }
        },
        async ListaCliente()
        {
            this.bus.$emit('ListCcliente');
        },
        Eliminar(Id)
        {
            this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result) => {
                if(result.value) {
                    this.$http.delete(
                        'crmoportunidad/' + Id
                    ).then( (res) => {
                        if (this.oclientesorigen!=undefined) {
                            let Obj=JSON.parse(sessionStorage.getItem("IdSaved"));
							Obj.Oportunidades--;
							sessionStorage.setItem("IdSaved",JSON.stringify(Obj));
                        }
                        this.$toast.success('Información eliminada');
                        this.Lista();
                    });
                }
            });
        },
        async Lista()
        {
            this.ConfigLoad.ShowLoader=true;
            let params={
                Nombre:this.Filtro.Nombre,
                RegEstatus:'A',
                Entrada:this.Filtro.Entrada,
                pag:this.Filtro.Pagina,
                Estado:this.Estado,
				Tipo:this.Categoria,
                Origen:1,
				FechaI:this.rangeDate.start,
                FechaF:this.rangeDate.end,
            }
            if (this.RolUsuario!="Admin" && this.RolUsuario!="Gerencia" && this.RolUsuario!="Gerente de ventas") {
                params.IdVendedor=this.IdUsuario;
				params.Responsable=this.Responsable;
            }
            if (this.oclientesorigen!=undefined) {
                params.IdClienteS=this.oClienteS.IdClienteS
            }
            await this.$http.get(
                this.urlApi,
                {
                    params:params
                }
            ).then( (res) => {
                this. ListaOportunidades =res.data.data.oportunidades;
				this.MontoOportunidadesClientes=res.data.data.montooportunidadesclientes;
				this.MontoOportunidadesProspectos=res.data.data.montooportunidadesprospectos;
                this.Filtro.Entrada=res.data.data.pagination.PageSize;
                this.Filtro.TotalItem=res.data.data.pagination.TotalItems;
                this.ConfigLoad.ShowLoader=false;

                if (this.pIdActivaRedireccion!=undefined) {
                    $("#oportunidadservicio").modal("show");
                    this.bus.$emit('NewModal_'+this.EmitSeccion,0,this.pIdActivaRedireccion);
                    this.pIdActivaRedireccion=undefined;
                }
            });
        },
        SeleccionarCliente(objeto)
        {
            this.oclientesuc=objeto;
            if (this.oclientesuc.Correo!='')
            {
                this.servicios.Para.push({ "text": this.oclientesuc.Correo});
            }
            let distacia=0;
            if(objeto.DistanciaAprox !='')
            {
                distacia=objeto.DistanciaAprox;
            }
            this.servicios.IdCliente=objeto.IdCliente;
            this.servicios.IdClienteS=objeto.IdClienteS;
            this.servicios.Cliente=objeto.Nombre;
            this.servicios.Direccion=objeto.Direccion;
            this.servicios.Distancia=distacia;
            this.servicios.Velocidad=0;
            this.ListaNumContrato();
        },
        IrACalendario(){
            this.$router.push({ name: "calendario" });
        },
		IrANuevasOportunidades(){
            this.$router.push({ name: "oportunidadesserviciolista", params: {} });
        },
		async GetListaVendedor(){
			await this.$http.get('vendedores/get',{
            	params:{
					RegEstatus: 'A'
				}
            }).then((res)=>{
				let Mapeado=res.data.data.Vendedores.map((Element)=>{
                    if (Element.IdUsuario==null) {
                        Element.IdUsuario=Element.TrabajadorUsuario,
                        Element.Nombre=Element.NombreAdmin
                        return Element;
                    }
                    else{
                        return Element;
                    }
                });
                this.ListaResponsable=Mapeado;
			})
		}
    },
    created()
    {

		var date = new Date(), y = date.getFullYear(), m = date.getMonth();
        var firstDay = new Date(y, m, 1);
        var lastDay = new Date(y, m + 1, 0);

        this.rangeDate={
            start:firstDay,
            end:lastDay
        }
		
        this.MostrarTodo=true;
        if (this.oclientesorigen!=undefined) {
            this.oClienteS=this.oclientesorigen;
            this.txtSitio="Volver";
            this.MostrarTodo=false;
        }
        let Usuario=JSON.parse(sessionStorage.getItem('user'));
        this.RolUsuario=Usuario.Perfil;
        this.NombreUsuario=Usuario.Nombre + ' ' + Usuario.Apellido;
        if (this.RolUsuario!="Admin") {
            this.IdUsuario=Usuario.IdUsuario;
        }
        this.bus.$off('SeleccionarCliente');

        this.bus.$on('SeleccionarCliente',(oSucursal)=>
        {
            //this.SeleccionarCliente(oSucursal);
            alert(JSON.stringify(oSucursal));
        });

        this.bus.$off('Delete_'+this.EmitSeccion);
        this.bus.$off('List');
        this.bus.$off('Regresar');
        this.Lista();

        this.bus.$on('Delete_'+this.EmitSeccion,(Id)=>
        {
            this.Eliminar(Id);
        });
        this.bus.$on('List',()=>
        {
            this.Lista();
        });
        this.bus.$on('RegresarCalendario',()=>
        {
            if (this.oclientesorigen!=undefined) {
                this.$router.push({
				    name: "crmcontactosucursal",
			    });   
            }
            else{
                this.$router.push({name:'submenucrm'});
            }
        });
		this.GetListaVendedor();
    },
    mounted() {
		if (this.pTitulo=='desarrollo') {
			this.NameList='Oportunidades Desarrollo';
		}
		else if (this.pTitulo=='servicio') {
			this.NameList='Oportunidades Ventas';
		}
        // $(".card-01").css('width','90%');
        // $(".card-01").css('margin-left','auto');
        // $(".card-01").css('margin-right','auto');

    },
}
</script>
